export default __webpack_public_path__ + "static/owner-b5c6246314edadad5c71133fd0d62848.jpg";